<template>
    <div class="main-footer">

        <footer v-cloak>
            <div class="container">
                <p class="footer-copyright">
                    &copy; {{ year }} Clean Air Construction
                </p>

                <b-nav class="footer-nav">
                    <b-nav-item to="/">
                        Home
                    </b-nav-item>
                    <li>|</li>
                    <b-nav-item href="https://www.portland.gov/omf/brfs/procurement/clean-air-construction/equipment-registration">
                        FAQ
                    </b-nav-item>
                    <li>|</li>
                    <b-nav-item to="/site/privacy">
                        Privacy
                    </b-nav-item>
                    <template v-if="$user.userId()">
                        <li>|</li>
                        <b-nav-item to="/support" v-if="$user.userId()">
                            Contact Support
                        </b-nav-item>
                    </template>
                </b-nav>
            </div>

        </footer>

    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'MainFooter',
    computed: {
        year () {
            return new Date().getFullYear()
        }
    }
})
</script>

<style lang="scss">


footer {
    padding-bottom: 1em;
    text-align: center;
    font-size: 14px !important;
    background-color: #fff;

    > .container {
        padding-top: 1em;
        padding-bottom: 1em;
        @media (min-width: 1024px) {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
}

.footer-nav {
    display: flex;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    color: #bbb;

    li {
        line-height: 30px;
    }

    a {
        color: #bbb;
        font-size: 12px;
        text-transform: uppercase;
        padding: 0 1em;

        &:hover {
            color: #fff;
        }
    }
}

p.footer-copyright {
    color: #bbb;
    @media (max-width: 1023px) {
      margin-top:1.5rem;
    }
    @media (min-width: 1024px) {
        margin-bottom: 0;
    }
}

#root-app footer {
    background-color: var(--black);
    position: relative;
    /*z-index: 1;*/
}

@media (max-width: 599px) {
    .footer-copyright__who-credit {
        font-size: 12px;
        display: block;
    }
}

.footer-copyright__divider {
    @media (max-width: 599px) {
        display: none;
    }
    @media (min-width: 600px) {
        margin: 0 10px;
    }
}

</style>